<template>
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 14 14">
    <g stroke="currentColor" stroke-width="2" stroke-linecap="square" fill="none">
      <circle cx="7" cy="7" r="6"></circle>
      <path d="M11.066 2.934l-7.628 7.628"></path>
    </g>
  </svg>
</template>
